import { useCallback, useContext, useEffect, useState } from 'react';
import { SearchContext } from './../context/search-context';
import { StoreContext } from './../context/store-context';

export const useSearch = () => useContext(SearchContext);
export const useStore = () => useContext(StoreContext);

export const useTableOfContents = (body, levels = ['heading1', 'heading2', 'heading3']) => {
  const [toc, setToc] = useState([]);

  const slugify = useCallback(
    (text) =>
      text
        .toLowerCase()
        .replace(/[^\w]+/g, '-')
        .replace(/^-+|-+$/g, ''),
    []
  );

  useEffect(() => {
    const headings = [];

    body
      .filter((block) => levels.includes(block?.type) || typeof block === 'string')
      .map((block) => {
        if (typeof block === 'string') {
          const parser = new DOMParser();
          const doc = parser.parseFromString(body, 'text/html');
          const elems = doc.querySelectorAll('h1, h2, h3');
          elems.forEach((elem) => {
            const level = parseInt(elem.tagName.replace('H', ''), 10);
            const text = elem.textContent;
            const id = slugify(text);
            headings.push({ text, level, id });
          });
        } else {
          const level = parseInt(block?.type?.replace('heading', ''), 10);
          const text = block.text;
          const id = slugify(text);
          headings?.push({ level, text, id });
        }
      });

    setToc(headings);
  }, [body]);

  return toc;
};
